/* Native Shopify customer events only. Pixel subscription/configuration lives in admin. */
(function () {
  if (window.boxBuddyEventsBound) return;
  window.boxBuddyEventsBound = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var name = /^tel:/i.test(href) ? 'boxbuddy:click_phone' : /^mailto:/i.test(href) ? 'boxbuddy:click_email' : null;
    if (!name) return;
    var shopify = window.Shopify;
    if (!shopify || !shopify.analytics || typeof shopify.analytics.publish !== 'function') return;
    if (!shopify.customerPrivacy || typeof shopify.customerPrivacy.analyticsProcessingAllowed !== 'function' || !shopify.customerPrivacy.analyticsProcessingAllowed()) return;
    // No form contents, phone numbers, email addresses, or query strings.
    try {
      var result = shopify.analytics.publish(name, { page_path: window.location.pathname });
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (error) {
      // Analytics must never interrupt the contact action.
    }
  });
}());
